import { Box, BoxProps } from "@chakra-ui/react";
import { ReactNode } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { CarouselArrow } from "./CarouselArrow";

const settings = {
  dots: false,
  fade: false,
  arrows: true,
  infinite: true,
  autoplay: false,
  speed: 500,
  autoplaySpeed: 5000,
  swipe: true,
  swipeToSlide: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  nextArrow: <CarouselArrow />,
  prevArrow: <CarouselArrow />,
};

export const Carousel: React.FC<
  { children: ReactNode | ReactNode[]; extraSettings?: object } & BoxProps
> = ({ children, extraSettings, ...rest }) => {
  const sliderSettings = { ...settings, ...extraSettings };
  // If there is a total of x items and we're trying to display x items
  // then don't show arrows or allow swiping i.e. turn off the carousel
  if (
    Array.isArray(children) &&
    sliderSettings.slidesToShow === children?.length
  ) {
    sliderSettings.arrows = false;
    sliderSettings.swipe = false;
  }

  return (
    <Box overflow="hidden" maxW="100%" {...rest}>
      <Slider {...sliderSettings}>{children}</Slider>
    </Box>
  );
};
